export const TENANT_STATUS_LABELS = {
  active: "Aktif",
  ending_soon: "Akan Berakhir",
  ended: "Berakhir",
};

export const TENANT_STATUS_STYLES = {
  active: "bg-emerald-100 text-emerald-700 border-emerald-200",
  ending_soon: "bg-amber-100 text-amber-700 border-amber-200",
  ended: "bg-secondary text-muted-foreground border-border",
};

export const RENTAL_PERIOD_LABELS = {
  daily: "Harian",
  monthly: "Bulanan",
  yearly: "Tahunan",
};

export const RENTAL_PERIOD_OPTIONS = [
  { value: "daily", label: "Harian" },
  { value: "monthly", label: "Bulanan" },
  { value: "yearly", label: "Tahunan" },
];
